import { AuthLayout } from "../commons/authLayout/authLayout";
import { ForgotPasswordForm } from "../features/forgotPasswordForm";

export const ForgotPasswordPage = () => {
  return (
    <AuthLayout>
      <ForgotPasswordForm />
    </AuthLayout>
  );
};
